import HealthParameters from "./SVG/graph-stats.svg?react";

const HealthParametersIcon = () => {
  return <HealthParameters />;
};

export default HealthParametersIcon;
